import React, { useState } from "react";
import "../../styles/Footer/Footer.css";
import { useToast } from "../Toast/ToastContainer";

const Footer = () => {
  const [email, setEmail] = useState("");
  const { showSuccess, showError } = useToast();

  const quickLinks = [
    "Home",
    "About Us",
    "Programs",
    "Partnerships",
    "Donate",
    "Contact",
  ];

  const handleSubscribe = () => {
    // Simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      showError("Please enter your email address");
      return;
    }

    if (!emailRegex.test(email)) {
      showError("Please enter a valid email address");
      return;
    }

    // In a real application, you would send this to a backend API
    showSuccess("Thank you for subscribing to our newsletter!");
    setEmail("");
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Foundation Info */}
          <div className="footer-section">
            <h2 className="footer-title">
              Phabyeon <span className="title-accent">Foundation</span>
            </h2>
            <p className="footer-description">
              Empowering communities through education and collaboration to
              create sustainable impact and foster global growth.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-section-title">Quick Links</h3>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href="#" className="footer-link">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs & Services */}
          <div className="footer-section">
            <h3 className="footer-section-title">Our Focus</h3>
            <ul className="footer-links">
              <li>
                <a href="#" className="footer-link">
                  Education Initiatives
                </a>
              </li>
              <li>
                <a href="#" className="footer-link">
                  Health & Wellness
                </a>
              </li>
              <li>
                <a href="#" className="footer-link">
                  Community Development
                </a>
              </li>
              <li>
                <a href="#" className="footer-link">
                  Scholarships
                </a>
              </li>
              <li>
                <a href="#" className="footer-link">
                  Success Stories
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="footer-section">
            <h3 className="footer-section-title">Newsletter</h3>
            <p className="newsletter-description">
              Subscribe to our newsletter for updates on grants, scholarships,
              and our global expansion.
            </p>
            <div className="newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your Email"
                className="email-input"
              />
              <button
                onClick={handleSubscribe}
                className="donate-button"
                style={{textTransform: "none", }}
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="bottom-content">
            <p className="copyright">
              © 2025 Phabyeon Burgess-Yearwood Foundation. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;